import React from 'react'
import { List, Confirm, Icon, Table, Image } from 'semantic-ui-react'
import Loading from '../../../components/loading'
import Empty from '../../../components/empty'
import ConfirmDevice from '../../../components/ConfirmDevice'
import {connect} from 'react-redux'
import {createAPIClient} from '../../../services/api'
import EditForm from './components/edit'

class DeviceContainer extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      error: undefined,
      isLoading: true,
      accessTokens: [],
      openConfirm: false,
      editDevice: undefined,
      showOwnerEditForm: false,
      editOwnerToken: undefined
    }
  }

  confirmDeviceAction (form) {
    const API = createAPIClient()
    if (!form.code) throw new Error('code is required')
    return API.post('/auth/device/confirm', form)
      .then(response => {
        return Promise.resolve()
      })
      .catch(error => {
        return Promise.reject(error.response.data)
      })
  }
  getAccessTokens () {
    const api = createAPIClient()
    api.get('/api/accesstokens')
      .then(response => {
        const {data} = response
        this.setState({
          accessTokens: data.response.items,
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error: error
        })
      })
  }

  onRemove (id) {
    if (!id) return
    const api = createAPIClient()
    api.delete(`/api/accesstokens/${id}`)
      .then(response => {
        this.getAccessTokens()
      })
  }
  componentDidMount () {
    // setup periodic refreshing of overview
    this.refresh = setInterval(this.getAccessTokens.bind(this), 4000)
    // this.refreshTokens()
    this.getAccessTokens()
  }
  componentWillUnmount () {
    // stop refreshing tokens
    clearInterval(this.refresh)
  }
  showConfirm (device) {
    this.setState({openConfirm: true, editDevice: device})
  }
  handleCancel () {
    this.setState({
      openConfirm: false,
      editDevice: undefined
    })
  }
  handleConfirm () {
    this.onRemove(this.state.editDevice._id)
    this.setState({openConfirm: false, editDevice: undefined})
  }
  finishOwnerEditing (reload = true) {
    this.setState({
      showOwnerEditForm: false,
      editOwnerToken: undefined
    })
    if (reload) {
      this.getAccessTokens()
    }
  }
  showOwnerEditing (device) {
    this.setState({
      showOwnerEditForm: true,
      editOwnerToken: device
    })
  }
  render () {
    const hasTokens = !!this.state.accessTokens.length
    const confirmStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
    if (this.state.isLoading) {
      return <Loading />
    }

    const overview = (<List divided verticalAlign='middle'>
      {hasTokens && this.state.accessTokens.map(device => {
        if (!device.is_valid) return null
        return (
          <List.Item key={device._id}>
            <List.Content floated='right'>
              <a style={{padding: '10px', color: '#4c4c4c'}} href='#' onClick={this.showOwnerEditing.bind(this, device)}>
                <Icon name='edit' />
                Edit
              </a>
              <a style={{padding: '10px', color: '#4c4c4c'}} href='#' onClick={this.showConfirm.bind(this, device)}>
                <Icon name='delete' />
                Unlink
              </a>
            </List.Content>
            <List.Content verticalAlign='middle'>{device.info} {device.owner ? '| ' + device.owner : ''}</List.Content>
          </List.Item>
        )
      })}
    </List>)
    const tableRows = (
      <Table.Body>
        {this.state.accessTokens.map(device => {
          return (
            <Table.Row key={device._id}>
              <Table.Cell>
                {(false) ? undefined : (
                  <a href='#'>
                    <Image onClick={this.showOwnerEditing.bind(this, device)} avatar src={'/icons/expand_1369826.svg'} />
                  </a>
                )}
              </Table.Cell>
              <Table.Cell>{device.info}</Table.Cell>
              <Table.Cell> {this.props.templates.templates.filter(e => device.templates.includes(e._id)).map(e => e.name).join(', ')} </Table.Cell>
              <Table.Cell>{device.owner}</Table.Cell>
              <Table.Cell>{device.list ? 'Allowed' : 'Restricted'}</Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )
    const table = (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{width: '50px'}} />
            <Table.HeaderCell>Info</Table.HeaderCell>
            <Table.HeaderCell>Forms</Table.HeaderCell>
            <Table.HeaderCell>Owner</Table.HeaderCell>
            <Table.HeaderCell>Issue list access</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {tableRows}
      </Table>
    )
    const unlinkConfirmModal = (
      <Confirm
        style={confirmStyle}
        open={this.state.openConfirm}
        onCancel={this.handleCancel.bind(this)}
        onConfirm={this.handleConfirm.bind(this)}
        content={`Are you sure you want to unlink ${this.state.editDevice && this.state.editDevice.info}?`}
        confirmButton='Yes, Unlink'
      />
    )
    return (
      <div>
        <h2>Devices</h2>
        {hasTokens ? table : (<Empty>No devices found right now. Start by adding one below.</Empty>)}
        {unlinkConfirmModal}
        <ConfirmDevice handleConfirmation={this.confirmDeviceAction} />
        {this.state.showOwnerEditForm ? (<EditForm
          showConfirm = {this.showConfirm.bind(this)}
          showEditForm={this.state.showOwnerEditForm}
          editOwnerToken={this.state.editOwnerToken}
          finishEditing={this.finishOwnerEditing.bind(this)}
        />) : undefined
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {entities: state.devices, templates: state.templates}
}

export default connect(mapStateToProps, {})(DeviceContainer)



// WEBPACK FOOTER //
// ./src/pages/settings/devices/index.js